import { RegularButton } from 'pg-ui-library';
import styled from 'styled-components';

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-grow: 2;
  background-color: #fff;
  min-width: 0px;
  row-gap: 10px;
  padding-bottom: 20px;
`;

export const Title = styled.p`
  font-size: 24px;
  font-weight: 600;
  color: #1c1b3a;
  padding: 10px 0 0 20px;
  margin-bottom: 10px;
`;

export const RowContainer = styled.div`
  display: flex;
  padding: 10px 0 0 20px;
`;

export const FlexContainer = styled.div`
  display: flex;
  gap: 30px;
  padding: 0 0 0 20px;
`;

export const DocumentsButton = styled(RegularButton)`
  margin: 0;
`;
